import React from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from 'react-tippy'
import { positionIcon, plusIcon, minusIcon, layerIcon, gridIcon } from '../assets/images'
import { selectedLayerSelector } from '../redux/selectedLayerSlice'
import LayerDetails from './LayerDetails'
import useUserLocation from '../hooks/useUserLocation'
import useLayerDetails from '../hooks/useLayerDetails'

const ZoomControl = ({
  onZoomIn,
  onZoomOut,
  handleToggleLayer,
  handleStyleChange,
  isPollutantsLayerActive,
  map
}) => {
  const selectedLayer = useSelector(selectedLayerSelector)
  const theme = useSelector((state) => state.mapStyle.darkMode ? 'dark' : 'light')
  const darkMode = useSelector((state) => state.mapStyle.darkMode)

  const handleUserLocationClick = useUserLocation(map)

  const {
    selectedLayerDetails,
    showLayerDetails,
    toggleShowLayerDetails,
    wrapperRef
  } = useLayerDetails(selectedLayer)

  return (
    <div
      className='fixed bottom-0 right-0 p-2 mb-10 sm:mb-0'
      ref={wrapperRef}
    >
      {showLayerDetails && selectedLayerDetails && (
        <div className='fixed right-36 bottom-26'>
          <LayerDetails handleLayerChange={handleToggleLayer} />
        </div>
      )}
      <div className='sm:mb-0 sm:mr-8 mb-8 mr-0 flex flex-col space-y-2'>
        <button
          className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center text-white text-xl font-bold shadow hover:bg-blue-500 transition-colors duration-300 ${
            theme === 'light' ? 'bg-white' : 'bg-zinc-700'
          }`}
          onClick={handleUserLocationClick}
        >
          <img src={positionIcon} alt='get current location' />
        </button>
        <Tooltip
          position='right' trigger='mouseenter' duration={3} html={(
            <div className='fixed sm:right-[-21px] sm:bottom-[-12px] w-14 px-1 py-2 text-xs text-white bg-[#353535] rounded-lg shadow-lg group-hover:block bottom-full'>
              <span className='text-[10px] font-bold px-1'>Sensors</span><br /> <span className='text-[10px] font-bold px-1'> Layer</span>
              <svg className='fixed right-[29px] w-2 h-2 text-[#353535] transform -translate-x-2/3 -translate-y-1/2 -rotate-90 fill-current' style={{ top: '50%', right: '-15%' }} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
                <polygon points='10,0 20,20 0,20' />
              </svg>
            </div>
)}
        >

          <button
            className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center text-white text-xl font-bold shadow hover:bg-blue-500 transition-colors duration-300 ${
              (theme === 'light' && isPollutantsLayerActive) ||
              (theme === 'dark' && isPollutantsLayerActive)
                ? 'bg-blue-500'
                : darkMode
                ? 'bg-zinc-700'
                : 'bg-white'
            }`}
            title='Sensors Layer'
            onClick={toggleShowLayerDetails}
          >
            <img src={layerIcon} alt='change layer button' />
          </button>
        </Tooltip>
        <Tooltip
          position='right' trigger='mouseenter' duration={4} html={(
            <div className='fixed right-[-21px] bottom-[-19px]  w-14 px-1 py-2 text-xs text-white bg-[#353535] rounded-lg shadow-lg group-hover:block bottom-full'>
              <span className='text-[10px] font-bold px-1'>Pixel</span><br /> <span className='text-[10px] font-bold px-1'> Layer</span>
              <svg className='fixed right-[28px] w-2 h-2 text-[#353535] transform -translate-x-2/3 -translate-y-1/2 -rotate-90 fill-current' style={{ top: '50%', right: '-15%' }} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
                <polygon points='10,0 20,20 0,20' />
              </svg>
            </div>
)}
        >
          <button
            className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center text-white text-xl font-bold shadow hover:bg-blue-500 transition-colors duration-300 ${
              (theme === 'light' && !isPollutantsLayerActive) ||
              (theme === 'dark' && !isPollutantsLayerActive)
                ? 'bg-blue-500'
                : darkMode
                ? 'bg-zinc-700'
                : 'bg-white'
            }`}
            onClick={handleStyleChange}
          >
            <img src={gridIcon} alt='grid view button' />
          </button>
        </Tooltip>

        <div className={`mb-8 mr-8 flex flex-col divide-y-2 ${theme === 'light' ? 'divide-slate-300' : 'divide-slate-200'}`}>
          <button
            className={`w-14 h-14 rounded-t-full shadow-lg flex items-center justify-center text-white text-xl font-bold  hover:bg-blue-500 transition-colors duration-300 sm:flex hidden ${
              theme === 'light' ? 'bg-white' : 'bg-zinc-700'
            }`}
            onClick={onZoomIn}
            title='Zoom In'
          >
            <img src={plusIcon} alt='zoom in button' />
          </button>
          <button
            className={`w-14 h-14 mb-20 rounded-b-full shadow-lg flex items-center justify-center text-white text-xl font-bold  hover:bg-blue-500 transition-colors duration-300 sm:flex hidden ${
              theme === 'light' ? 'bg-white' : 'bg-zinc-700'
            }`}
            onClick={onZoomOut}
            title='Zoom Out'
          >
            <img src={minusIcon} alt='zoom out button' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ZoomControl
